// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__11xsR","validationTips":"StatementDescriptor_validationTips__2YwUJ"};